


































































// import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import UserGroupContainer from './user-group-container.vue';
import UsersContainer from './users-container.vue';
import ScopeContainer from './scope-container.vue';
import PermissionsContainer from './permission-container.vue';
import  { MswApiService } from '@/shared/msw-api-service';
import { UserGroupReponse, PermissionApiResponse, PartyGroupPermissionSection, MSSPPrefilterResponseType, DeleteUserDataType, AddUserToUserGroupBodyType, ScopeUserGroupResponse, UserGroup } from './userGroupTypes';
import AddUser from './add-user.vue';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { UserModalType } from './types';
import UserModal from './userModal.vue';
import { confirmService } from '@libs-uuif/shared/confirm-service';
import { currentUserKey } from '@/shared/msw-constants';
import { SwBlockingProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-blocking-progress';

const cssPrefix = 'access-mgmt-user-group';
@Component({
  components: {
    ...UUIFComponents,
    UserGroupContainer,
    UsersContainer,
    ScopeContainer,
    PermissionsContainer,
    AddUser,
    UserModal,
    SwBlockingProgress,
  },
})
export default class AccessMgmtUserGroup  extends SwExtendedVue {
  cssPrefix = cssPrefix;
  selectedUserGroup = {};
  permissionApiResponse: PartyGroupPermissionSection[] = [];
  enableAddUserModal: boolean = false;
  msspPrefilterResponseFromApi: MSSPPrefilterResponseType = {
    content: {
      MSSPs: [],
      Products: [],
      ProvisionMSSP: '',
      ProvisionTenant: '',
      ProvisionProduct: '',
      ProvisionTenantMsg: '',
      ProvisionProductMsg: '',
    },
    operationStatus: '',
    msgCode: '',
    msgId: '',
    msgDesc: '',
  };
  activeMsspOptions: SelectOption[] = [];
  allMsspOptions: SelectOption[] = [];
  enaleInviteUserModal: boolean = false;
  defaultPropData: UserModalType = {
    emailAddress: '',
    firstName: '',
    lastName: '',
    selectedMssp: '',
    selectedContactType: '',
    userGroup: [],
  };
  userModalDataProp: UserModalType = this.defaultPropData;
  userGroupDetails: UserGroupReponse['userGroups'] = [];
  selectedMssp: string = '';
  msspScopeFlag: boolean = false;
  tenantScopeFLag: boolean = false;
  masterMsspRole: boolean = false;
  visible: boolean = false;

  async addUsersToUserGroupFn(addUserBody: AddUserToUserGroupBodyType) {
    try {
      this.$store.commit('startLoading');
      await this.addNewUserToUserGroupApi(addUserBody);
      await this.getUserGroupApiDetails('usersContainer');
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }
  async createNewUserGroup(userGroupName: string) {
    const selectedMsspId = this.$store.getters['AccessManagementStoreModule/getSelectedMssp'] || '';
    const bodyToBePosted = {
      newusergroup: userGroupName,
      msspId: selectedMsspId,
    };
    try {
      this.$store.commit('startLoading');
      await this.addNewUserGroupApi(bodyToBePosted);
      await this.getUserGroupApiDetails('createUserGroup', userGroupName);
      await this.formatNewUserGroup(userGroupName, true);
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  formatNewUserGroup(userGroupName: string, name: boolean, partyGroupId: string = '') {
    const selctedUserGroupRow = this.userGroupDetails.filter((ele: any) =>  name ? (ele.partyGroupName === userGroupName) : (ele.partyGroupId === partyGroupId))[0];
    const selectedUserGroupObj = {
      partyGroupName: selctedUserGroupRow.partyGroupName,
      isDefaultGroup: selctedUserGroupRow.isDefaultGroup,
      partyGroupId: selctedUserGroupRow.partyGroupId,
      adminPartyId: selctedUserGroupRow.adminPartyId,
      status: selctedUserGroupRow.status,
      totalContacts: selctedUserGroupRow.totalContacts,
      productGroupName: selctedUserGroupRow.productGroupName,
      associatedPGList: selctedUserGroupRow.associatedPGList,
      setAsDefaultGroup: selctedUserGroupRow.setAsDefaultGroup,
      renameLink: selctedUserGroupRow.renameLink,
      usersForUserGroup: selctedUserGroupRow.usersForUserGroup,
      deleteLink: selctedUserGroupRow.deleteLink,
      mgeProdGrpPagelink: selctedUserGroupRow.mgeProdGrpPagelink,
      isReadOnlyAccess: selctedUserGroupRow.isReadOnlyAccess,
      MSSPID: selctedUserGroupRow.MSSPID,
      isAllMSSPTenants: selctedUserGroupRow.isAllMSSPTenants,
      msspScope: selctedUserGroupRow.msspScope,
      scopedMSSPID: selctedUserGroupRow.scopedMSSPID,
    };
    this.$store.commit('AccessManagementStoreModule/setSelectedUserGroupObject', { selectedUserGroupObject: selectedUserGroupObj });
  }

  addNewUserToUserGroupApi(data: any) {
    return new Promise((res, rej) => {
      MswApiService.userGroup.saveUsersToUserGroup(data)
      .then((resp: any) => {
        this.enableAddUserModal = false;
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        }
        res(true);
      })
      .catch(() => {
        rej(true);
      });
    });
  }

  addNewUserGroupApi(data: any) {
    return new Promise((res, rej) => {
      MswApiService.userGroup.addUserGroup(data)
      .then((resp: any) => {
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          rej(true);
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        }
        res(true);
      })
      .catch(() => {
        rej(true);
      });
    });
  }

  async onSaveScopeMsspFn(allTenant: boolean, msspId: string, permissionCheckBox: string[], scopeSelected: string, msspAPI: boolean, tenantApi: boolean) {
    try {
      this.$store.commit('startLoading');
      if (tenantApi) {
        const productGroupList = permissionCheckBox.map((ele: string) => {
          return {
            productGroupId: ele,
            partyGroupId: this.userGroupSelected.partyGroupId || '',
          };
        });
        const dataToBePosted = {
          partyProductGroupList: productGroupList,
          msspID: this.userGroupSelected.MSSPID,
        };
        await this.saveScopeApiForTenant(dataToBePosted);
      }
      if (msspAPI) {
        const dataToBePosted = {
          partyGroupid: this.userGroupSelected.partyGroupId || '',
          MasterMSSPID: this.userGroupSelected.MSSPID || '',
          newMasterMSSPID: msspId,
          isMSSPGlobal: allTenant || scopeSelected === 'allTenants' ? 'GLOBAL' : scopeSelected === 'mssp' ? 'MSSP' : 'TENANTS',
        };
        await this.saveScopeApi(dataToBePosted);
      }
      if (this.msspScopeFlag || this.tenantScopeFLag) {
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: String(this.$t('accessMgmt.Updated'))
        .concat(this.msspScopeFlag ? String(this.$t('accessMgmt.mssp')) :  '', this.msspScopeFlag && this.tenantScopeFLag ? String(this.$t('accessMgmt.and')) :  '', this.tenantScopeFLag ? String(this.$t('accessMgmt.selec')) :  '' , String(this.$t('accessMgmt.for'))) });
      }
      await this.getUserGroupApiDetails();
      await this.formatNewUserGroup('', false, this.userGroupSelected.partyGroupId);
      await this.loadScopeApi(this.userGroupSelected.partyGroupId, this.userGroupSelected.MSSPID);
        // getscopeApi
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  saveScopeApi(data: any) {
    return new Promise((res, rej) => {
      MswApiService.userGroup.saveUserGroupScope(data)
      .then((resp: any) => {
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        } else {
          this.msspScopeFlag = true;
        }
        res(true);
      })
      .catch(() => {
        rej(true);
      });
    });
  }

  saveScopeApiForTenant(data: any) {
    return new Promise((res, rej) => {
      MswApiService.userGroup.saveUserGroupTenantScope(data)
      .then((resp: any) => {
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        } else {
          this.tenantScopeFLag = true;
        }
        res(true);
      })
      .catch(() => {
        rej(true);
      });
    });
  }

  async savePermission(permissionListData: any) {
    const dataToBePosted: any = {
      partygroupid: this.userGroupSelected.partyGroupId || '',
      permissionList: permissionListData,
    };
    try {
      this.$store.commit('startLoading');
      await this.savePermissionApi(dataToBePosted);
      this.loadPermission(dataToBePosted.partygroupid);
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  savePermissionApi(data: any) {
    return new Promise((res, rej) => {
      MswApiService.userGroup.saveUserPermission(data)
      .then((resp: any) => {
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        }
        res(true);
      })
      .catch(() => {
        rej(true);
      });
    });
  }

  onDeleteUser(entry: any) {
    confirmService.confirm({
      status: 'major',
      title: String(this.$t('accessMgmt.deleteUser')),
      message: String(this.$t('accessMgmt.deleteSure')),
      buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('accessMgmt.confirm')), isDefault: true }],
    })
    .then((isConfirmed : any) => {
      if (isConfirmed === 'ok') {
        this.deleteUserAction(entry);
      }
    });

  }

  async deleteUserAction(entry: any) {
    const dataToBePosted: DeleteUserDataType = {
      bsendMail: null,
      contactLists: [
        {
          partyGroupId: entry.partyGroupId,
          partyId: entry.partyId,
          action: 'delete',
        },
      ],
    };
    try {
      this.$store.commit('startLoading');
      await this.deleteUserGroupApi(dataToBePosted);
      await this.getUserGroupApiDetails('usersContainer');
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  deleteUserGroupApi(dataToBePosted: DeleteUserDataType) {
    return new Promise((res, rej) => {
      MswApiService.userGroup.deleteUser(dataToBePosted)
      .then((resp: any) => {
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        }
        res(true);
      })
      .catch(() => {
        rej(true);
      });
    });
  }

  get userGroupSelected() {
    return this.$store.getters['AccessManagementStoreModule/getSelectedUserGroupObject'];
  }

  onSetUserGroup() {
    const selectedUserGroup = this.userGroupSelected;
    this.loadPermission(selectedUserGroup.partyGroupId);
    this.loadScopeApi(selectedUserGroup.partyGroupId, selectedUserGroup.MSSPID);
  }

  loadPermission(prtyGroupId: string) {
    this.$store.commit('startLoading');
    MswApiService.userGroup.getUserGroupPermissionList(prtyGroupId)
    .then((resp: PermissionApiResponse) => {
      this.permissionApiResponse = resp.content ? resp.content.PartyGroupPermissionSections : [];
      this.$store.commit('AccessManagementStoreModule/setPermissions', { PartyGroupPermissionSections: this.permissionApiResponse });
      this.$store.commit('stopLoading');
    })
    .catch(() => {
      this.$store.commit('stopLoading');
    });
  }

  loadScopeApi(prtyGroupId: string, msspId: string) {
    this.$store.commit('startLoading');
    MswApiService.userGroup.getUserGroupScopeData(prtyGroupId, msspId)
    .then((resp: ScopeUserGroupResponse) => {
      this.$store.commit('AccessManagementStoreModule/setUserGroupScopeData', { userGroupScopeInfo: resp.content ? {
        availbleProductGroup: resp.content.availbleProductGroup || [],
        assignedProductGroup: resp.content.assignedProductGroup || []} : [] });
      this.$store.commit('stopLoading');
    })
    .catch(() => {
      this.$store.commit('stopLoading');
    });
  }

  onCloseAddUserModal() {
    this.enableAddUserModal = false;
  }

  onAddUser() {
    this.enableAddUserModal = true;
  }

  onCancelAddUserModal() {
    this.enableAddUserModal = false;
  }

  onInviteNewUser() {
    this.enableAddUserModal = false;
    this.enaleInviteUserModal = true;
  }

  async closeModal(loadPage: boolean) {
    try {
      this.$store.commit('startLoading');
      this.enaleInviteUserModal = false;
      if (loadPage) {
        await this.getUserGroupApiDetails('usersContainer');
      }
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  resetSelectedUserGroup() {
    const selectedUSerGroupObject = Object.assign({}, {
      partyGroupName: '',
      isDefaultGroup: '',
      partyGroupId: '',
      adminPartyId: '',
      status: '',
      totalContacts: '',
      productGroupName: '',
      associatedPGList: [],
      setAsDefaultGroup: '',
      renameLink: '',
      usersForUserGroup: [],
      deleteLink: '',
      mgeProdGrpPagelink: '',
      isReadOnlyAccess: '',
      MSSPID: '',
      isAllMSSPTenants: '',
      msspScope: '',
      scopedMSSPID: '',
    });
    this.$store.commit('AccessManagementStoreModule/setSelectedUserGroupObject', { selectedUserGroupObject: selectedUSerGroupObject });
  }

  getUserGroupApiDetails(action: string = '', userGroupName: string = '') {
    return new Promise((res: any) => {
      const dataToBePosted = {
        isForced: 'true',
        mode: '',
        masterMSSPID: action === 'createUserGroup' ? this.$store.getters['AccessManagementStoreModule/getSelectedMssp'] || '' : this.userGroupSelected.MSSPID,
        isfromMSSPPage: 'YES',
        skipUsers: 'NO',
      };
      // MswApiService.userGroup.getUserGroupList()
      MswApiService.userGroup.getUserGroupListForMsspId(dataToBePosted)
      .then((resp: UserGroupReponse) => {
        this.userGroupDetails = [...resp.userGroups] || [];
        if (action === 'createUserGroup') {
          this.formatNewUserGroup(userGroupName, true);
        }
        if (action === 'usersContainer') {
          const selectedUserGroup = resp.userGroups.filter((ele: UserGroup) => ele.partyGroupId === this.userGroupSelected.partyGroupId)[0] || {};
          this.$store.commit('AccessManagementStoreModule/setUsersForUserGroups', { usersForUserGroup: selectedUserGroup.usersForUserGroup || [] });
        }
        this.$store.commit('AccessManagementStoreModule/setUserGroups', { userGroups: resp.userGroups || [] });
        this.$store.commit('AccessManagementStoreModule/setisRestrictedMSSPAccess', { isRestrictedMSSPAccess: resp.isRestrictedMSSPAccess });
        res(true);
      })
      .catch(() => {
        res(true);
      });
    });
  }

  formatMSSPList() {
    const msspOption: SelectOption[] = [];
    this.allMsspOptions = [];
    const globalList: SelectOption[] = [];
    if (this.msspPrefilterResponseFromApi && this.msspPrefilterResponseFromApi.content && this.msspPrefilterResponseFromApi.content.MSSPs) {
      this.msspPrefilterResponseFromApi.content.MSSPs.map((ele: any) => {
        if (ele.MSSPName && ele.MSSPStatus === 'ACTIVE') {
          if (ele.isGlobal === 'YES') {
            globalList.push({
              id: ele.MSSPID.toString(),
              label: ele.MSSPName,
              value: ele.MSSPID,
            });
          } else {
            msspOption.push({
              id: ele.MSSPID.toString(),
              label: ele.MSSPName,
              value: ele.MSSPID,
            });
          }
        }
        this.allMsspOptions.push({
          id: ele.MSSPID.toString(),
          label: ele.MSSPName,
          value: ele.MSSPID,
        });
      });
    }
    this.activeMsspOptions = [...globalList, ...msspOption];
    this.selectedMssp = this.activeMsspOptions[0] ? this.activeMsspOptions[0].id : '';
    this.$store.commit('AccessManagementStoreModule/setSelectedMssp', { selectedMssp: this.selectedMssp });
    this.$store.commit('AccessManagementStoreModule/setSelectedMsspObject', { selectedMsspObject:  this.fetchSelectedMsspDetails(this.selectedMssp) });
  }

  fetchSelectedMsspDetails(id: string) {
    let msspDetails = {
      MSSPName: '',
      MSSPID: 0,
      Tenants: [],
      isGlobal: '',
    };
    this.msspPrefilterResponseFromApi.content.MSSPs.map((ele: any) => {
      if (ele.MSSPID.toString() === id) {
        msspDetails = Object.assign({}, {
          MSSPName: ele.MSSPName,
          MSSPID: ele.MSSPID,
          Tenants: ele.Tenants || [],
          isGlobal: ele.isGlobal,
        });
      }
    });
    return msspDetails;
  }
  fetchMsspPrefilterList() {
    return new Promise((res: any) => {
      MswApiService.usageReport.getMsspList()
      .then((resp: MSSPPrefilterResponseType) => {
        this.msspPrefilterResponseFromApi = resp;
        if (this.msspPrefilterResponseFromApi.content.pendoEnabled &&
          this.msspPrefilterResponseFromApi.content.pendoEnabled === 'YES' &&
          this.msspPrefilterResponseFromApi.content.showPendo && this.msspPrefilterResponseFromApi.content.showPendo !== 'YES') {
          this.startPendoAnalytics();
        }
        this.formatMSSPList();
        res(true);
      })
      .catch(() => {
        res(true);
      });
    });
  }

  async fetchUserGroupUserDetails() {
    try {
      this.visible = true;
      await this.fetchMsspPrefilterList();
      await this.getUserGroupApiDetails();
      setTimeout(() => { this.visible = false; }, 4000);
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  checkForMasterMsspRole() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    if (userInfoObtained.roles) {
      if (Array.isArray(userInfoObtained.roles)) {
        return userInfoObtained.roles.some((role: string) => { return role.indexOf('MASTERMSSP') > -1; });
      }
      if (typeof userInfoObtained.roles === 'string') {
        return userInfoObtained.roles.includes('MASTERMSSP');
      }
    }
    return false;
  }

  initializeValues() {
    this.masterMsspRole = this.checkForMasterMsspRole();
  }

  created() {
    this.initializeValues();
    this.resetSelectedUserGroup();
    this.fetchUserGroupUserDetails();
  }

  beforeDestroy() {
    this.resetSelectedUserGroup();
  }

  startPendoAnalytics() {
    const currentUser : any = localStorage.getItem(currentUserKey);
    const userDetails = JSON.parse(currentUser) || '';
    if (userDetails !== '') {
      (window as any).pendo.initialize({
        visitor: {
          id: userDetails.userId || '',
          username: userDetails.userId || '', // For SFDC integ //
          org:  this.msspPrefilterResponseFromApi.content.orgName || '', // email domain //
          mssp: this.msspPrefilterResponseFromApi.content.MSSPTier || '', // MSSP tier //
        },
        account: {
          id: this.msspPrefilterResponseFromApi.content.orgID || '',  // OrgId for Company//
          name: this.msspPrefilterResponseFromApi.content.orgName || '', // Org Name
        },
      });
    }
  }
}
